import { Quote } from "lucide-react";
import { Section, highlight } from "./shared";

export function MainIdeasSection({ mainIdeas, regex }) {
  if (!mainIdeas?.length) return null;
  return (
    <Section label="Main Ideas">
      <ul className="space-y-2">
        {mainIdeas.map((m, i) => (
          <li key={i} className="text-sm">
            <span className="font-heading font-bold">{highlight(m.idea, regex)}</span>
            {m.explanation && (
              <span className="block text-zinc-700 mt-0.5">{highlight(m.explanation, regex)}</span>
            )}
          </li>
        ))}
      </ul>
    </Section>
  );
}

export function QuotesSection({ quotes, regex }) {
  if (!quotes?.length) return null;
  return (
    <Section label="Quotes">
      <div className="space-y-3">
        {quotes.map((q, i) => (
          <blockquote key={i} className="border-l-4 border-black bg-[#DBEAFE]/40 pl-4 pr-3 py-2 text-sm">
            <div className="flex items-start gap-2">
              <Quote className="w-3.5 h-3.5 text-[#3B82F6] flex-shrink-0 mt-1" />
              <span className="italic">&ldquo;{highlight(q.quote, regex)}&rdquo;</span>
            </div>
            {(q.source || q.context) && (
              <p className="mt-1 pl-5 text-xs text-zinc-500">
                {q.source && <span className="font-mono uppercase tracking-widest">— {q.source}</span>}
                {q.context && <span className="ml-2">· {q.context}</span>}
              </p>
            )}
          </blockquote>
        ))}
      </div>
    </Section>
  );
}
